import * as React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

function subtitle(props) {
  return (
    <Typography component="h5" variant="h10" color="secondary" gutterBottom>
      {props.children}
    </Typography>
  );
}

subtitle.propTypes = {
  children: PropTypes.node,
};

export default subtitle;